// User
export const CONTACT_FORM = '/contact-form';
export const GET_GIVEAWAY = '/question/giveaway';
export const LOGIN = '/login_check';
export const TOKEN_REFRESH = '/token_refresh';
export const CURRENT_USER = '/user/current';
export const LOGOUT = '/logout';
export const USERS = '/client/users';
export const USER = '/client';
export const PASSWORD_RECOVERY = '/password-recovery';
export const PASSWORD_RECOVERY_TOKEN = '/password-recovery-token';
export const FACEBOOK_CREATE_USER = '/facebook_create';
export const FACEBOOK_LOGIN = '/facebook_login';
export const GET_MIN_REMAINING_QUESTIONS = '/get-min-remaining-questions';
export const EXPORT_USER_DATA = '/export/currentUser';

// Contact
export const CONTACT = '/user/contact/';
export const CONTACTS = '/user/contacts';
export const CURRENT_CONTACT_TOKEN = '/current_contact_token';
export const CURRENT_CONTACT_TOKEN_FORCED = CURRENT_CONTACT_TOKEN + '/force';
export const SEND_TOKEN_BY_EMAIL = '/send-token-by-email';
export const REMOVE_CONTACT = '/user/remove_contact/';

// STATS
export const STATS_NOTION = '/stats_notions';
export const STATS_THEME = '/stats_themes';
export const STATS_VISION = '/stats_visions';

// SHOP
export const OFFERS = '/offers-client';
export const CREATE_TRANSACTION = '/transaction/create';
export const EXECUTE_TRANSACTION = '/transaction/execute';
export const TRANSACTIONS = '/transaction/list';

// TOPICS
export const TOPICS = '/user-packs';
export const TOPIC = '/packs/';

// POSTS
export const POSTS = '/client-posts';

// QUESTIONS
export const QUESTIONS_FINISHED = '/current_user_answer_count?isFantasy=false&isAction=false&answer[exists]=false';
export const QUESTION = '/question/';
export const CURRENT_QUESTION = '/question/current';
export const CURRENT_QUESTION_BY_PACK = '/question/pack/';
export const UPDATE_BOOKMARK = '/update-bookmark/';



// WEBPACK FOOTER //
// ./src/constants/api-routes.js